const PAIR_SYMBOL_TO_PAIR_ADDRESS = {
  WMATIC_USDC: "0x6e7a5fafcec6bb1e78bae2a1f0b612012bf14827"
};

const PAIR_ADDRESS_TO_REWARDS_POOL = {
  [PAIR_SYMBOL_TO_PAIR_ADDRESS.WMATIC_USDC]: "0x14977e7e263ff79c4c3159f497d9551fbe769625"
};

const PAIR_ADDRESS_TO_REWARDS_LENGTH = {
  [PAIR_SYMBOL_TO_PAIR_ADDRESS.WMATIC_USDC]: 2,
};

const PAIR_ADDRESS_TO_SUSHIBAR_REWARDS = {
  [PAIR_SYMBOL_TO_PAIR_ADDRESS.WMATIC_USDC]: [true, false],
};

const PAIR_ADDRESS_TO_UNWRAPPED_SUSHIBAR_REWARDS = {
  [PAIR_SYMBOL_TO_PAIR_ADDRESS.WMATIC_USDC]: ["0x831753dd7087cac61ab5644b308642cc1c33dc13"],
};

module.exports = {
  PAIR_SYMBOL_TO_PAIR_ADDRESS,
  PAIR_ADDRESS_TO_REWARDS_POOL,
  PAIR_ADDRESS_TO_REWARDS_LENGTH,
  PAIR_ADDRESS_TO_UNWRAPPED_SUSHIBAR_REWARDS,
  PAIR_ADDRESS_TO_SUSHIBAR_REWARDS
};

